import { reminderSettings } from '~/config/settings/reminder.settings';
import { datetime } from '~/tools/datetime';

const newSurveyReminderFrom = (survey) => {
  return {
    surveyId: survey.id,
    reminderId: null,
    scheduledDateTime: datetime.add(new Date(), { minutes: reminderSettings.EXTRA_MINUTES }).toISOString(),
    status: null,
    survey: {
      id: survey.id,
      surveyStatusId: survey.status.id,
      startTimeUTC: new Date(Number(survey.startTimeUTC)).toISOString(),
      // End time doesn't exist for continuous surveys
      endTimeUTC: survey.endTimeUTC ? new Date(Number(survey.endTimeUTC)).toISOString() : null,
    },
    languages: survey?.namesPerLanguage?.map((lang) => ({
      languageId: lang.language.id,
      emailSubject: lang?.emailSubject,
      emailBody: lang?.emailBody,
    })),
    timezone: survey.timezone,
  };
};

export { newSurveyReminderFrom };
